var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-auth-popup w-64 bsx-p-6"},[_c(_vm.comp,{tag:"component",on:{"changeView":_vm.goToPopup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }